//
//  WorkspaceProfile.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceProfile {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.name = model.name;
        this.color = model.color;
        this.avatar = (_a = model.avatar) !== null && _a !== void 0 ? _a : null;
        this.billingDetails = model.billingDetails
            ? {
                firstName: (_b = model.billingDetails.firstName) !== null && _b !== void 0 ? _b : null,
                lastName: (_c = model.billingDetails.lastName) !== null && _c !== void 0 ? _c : null,
                address: model.billingDetails.address
                    ? {
                        postal: (_d = model.billingDetails.address.postal) !== null && _d !== void 0 ? _d : null,
                        street1: (_e = model.billingDetails.address.street1) !== null && _e !== void 0 ? _e : null,
                        street2: (_f = model.billingDetails.address.street2) !== null && _f !== void 0 ? _f : null,
                        city: (_g = model.billingDetails.address.city) !== null && _g !== void 0 ? _g : null,
                        country: (_h = model.billingDetails.address.country) !== null && _h !== void 0 ? _h : null,
                        state: (_j = model.billingDetails.address.state) !== null && _j !== void 0 ? _j : null,
                    }
                    : null,
                email: (_k = model.billingDetails.email) !== null && _k !== void 0 ? _k : null,
                companyName: (_l = model.billingDetails.companyName) !== null && _l !== void 0 ? _l : null,
                companyId: (_m = model.billingDetails.companyId) !== null && _m !== void 0 ? _m : null,
                notes: (_o = model.billingDetails.notes) !== null && _o !== void 0 ? _o : null,
                vat: (_p = model.billingDetails.vat) !== null && _p !== void 0 ? _p : null,
            }
            : null;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs directly manipulable update object for workspace profile */
    toProfileUpdateObject() {
        return {
            name: this.name,
            color: this.color,
        };
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        return {
            name: this.name,
            color: this.color,
            avatar: (_a = this.avatar) !== null && _a !== void 0 ? _a : undefined,
            billingDetails: {
                firstName: (_c = (_b = this.billingDetails) === null || _b === void 0 ? void 0 : _b.firstName) !== null && _c !== void 0 ? _c : undefined,
                lastName: (_e = (_d = this.billingDetails) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : undefined,
                address: ((_f = this.billingDetails) === null || _f === void 0 ? void 0 : _f.address)
                    ? {
                        postal: (_h = (_g = this.billingDetails) === null || _g === void 0 ? void 0 : _g.address.postal) !== null && _h !== void 0 ? _h : undefined,
                        street1: (_k = (_j = this.billingDetails) === null || _j === void 0 ? void 0 : _j.address.street1) !== null && _k !== void 0 ? _k : undefined,
                        street2: (_m = (_l = this.billingDetails) === null || _l === void 0 ? void 0 : _l.address.street2) !== null && _m !== void 0 ? _m : undefined,
                        city: (_p = (_o = this.billingDetails) === null || _o === void 0 ? void 0 : _o.address.city) !== null && _p !== void 0 ? _p : undefined,
                        country: (_r = (_q = this.billingDetails) === null || _q === void 0 ? void 0 : _q.address.country) !== null && _r !== void 0 ? _r : undefined,
                        state: (_t = (_s = this.billingDetails) === null || _s === void 0 ? void 0 : _s.address.state) !== null && _t !== void 0 ? _t : undefined,
                    }
                    : undefined,
                email: (_v = (_u = this.billingDetails) === null || _u === void 0 ? void 0 : _u.email) !== null && _v !== void 0 ? _v : undefined,
                companyName: (_x = (_w = this.billingDetails) === null || _w === void 0 ? void 0 : _w.companyName) !== null && _x !== void 0 ? _x : undefined,
                companyId: (_z = (_y = this.billingDetails) === null || _y === void 0 ? void 0 : _y.companyId) !== null && _z !== void 0 ? _z : undefined,
                notes: (_1 = (_0 = this.billingDetails) === null || _0 === void 0 ? void 0 : _0.notes) !== null && _1 !== void 0 ? _1 : undefined,
                vat: (_3 = (_2 = this.billingDetails) === null || _2 === void 0 ? void 0 : _2.vat) !== null && _3 !== void 0 ? _3 : undefined,
            },
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using fromTransport */
    toTransport() {
        return this.toRemote();
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new WorkspaceProfile(model);
    }
}
